const units = [{
  name: 'thousand',
  ratio: 1000,
  text: '千'
}, {
  name: 'tenThousand',
  ratio: 10000,
  text: '万'
}, {
  name: 'hundredThousand',
  ratio: 100000,
  text: '十万'
}, {
  name: 'million',
  ratio: 1000000,
  text: '百万'
}, {
  name: 'tenMillion',
  ratio: 10000000,
  text: '千万'
}, {
  name: 'hundredMillion',
  ratio: 100000000,
  text: '亿'
}, {
  name: 'billion',
  ratio: 1000000000,
  text: '十亿'
}]

export default function (value, from, to = 'auto') {
  const number = Number.parseFloat(value)
  if (!number && number !== 0) return
  if (number === 0) return number.toFixed(2)
  const fromUnit = units.find(unit => unit.name === from || unit.text === from)

  if (to !== 'auto') {
    const toUnit = units.find(unit => unit.name === to || unit.text === to)

    if (fromUnit && toUnit) {
      return `${(number * toUnit.ratio / fromUnit.ratio).toFixed(2)}${toUnit.text}`
    } else {
      console.warn(`format filter: unit ${fromUnit ? toUnit : fromUnit} not exist`)
      return number
    }
  } else {
    if (fromUnit) {
      // 自动转换成 万 或 亿
      const val = number * fromUnit.ratio
      let toUnit = units.find(unit => unit.name === 'hundredMillion')
      if (Math.abs(val / toUnit.ratio) < 1) {
        toUnit = units.find(unit => unit.name === 'tenThousand')
      }
      return `${(val / toUnit.ratio).toFixed(2)}${toUnit.text}`
    } else {
      console.warn(`format filter: unit ${fromUnit} not exist`)
    }
  }
}
